import type { VaasCourse, VaasListItem } from "~/v2/types/vaas"

const getVaasStatus = (course: VaasCourse): VaasListItem["status"] => {
  if (course.archived === 1 && course.published === 0) {
    return "archived"
  }

  if (course.published === 1) {
    return "published"
  }

  if (
    course.published === 0 &&
    course.has_been_published === 1 &&
    course.archived === 0
  ) {
    return "unpublished"
  }

  return "draft"
}

const getLessonState = (course: VaasCourse): string => {
  const lessonCount = course.lessons?.length || 0

  if (lessonCount === 0) {
    return "No lesson attached"
  }

  if (lessonCount === 1) {
    return "1 lesson attached"
  }

  return `${lessonCount} lessons attached`
}

const mapCourseToVaasListItem = (course: VaasCourse): VaasListItem => {
  return {
    course,
    courseId: course.id,
    containerId: course.container_id,
    hasVaasLink: Boolean(course.vaas_id || course.vaas_logo_redirect),
    lessonCount: course.lessons?.length || 0,
    lessonState: getLessonState(course),
    name: course.name || `Untitled VAAS ${course.id}`,
    status: getVaasStatus(course),
    updatedLabel: course.updated?.format?.("M/D/YYYY") || "Unknown",
    vaasId: course.vaas_id || null,
    version: course.version,
  }
}

export { getVaasStatus, mapCourseToVaasListItem }
